import { useMemo } from 'react';

import type { ShareChannel, UseShareActionsOptions } from '#src/app/shared/hooks/share';

import { useGetShareContent } from './content';
import { useOnShareFailure } from './failure';
import { useOnShareSuccess } from './success';
import { useGetShareTrackingData } from './tracking';

export function useShareOptions(): UseShareActionsOptions<ShareChannel> {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();
	const onSuccess = useOnShareSuccess();
	const onFailure = useOnShareFailure();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getContent,
			getTrackingData,
			onSuccess,
			onFailure,
			config: {
				facebook: { mode: { mobile: 'url', desktop: 'sdk' } }, // Disable Facebook SDK by default on mobile to avoid a bug with the share dialog. See https://change.atlassian.net/browse/CHANGE-75410
			},
		}),
		[getContent, getTrackingData, onSuccess, onFailure],
	);
}
